import { useQuery } from '@tanstack/react-query';

import { DeclarationStatus } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface HookProps {
  batchId: string;
  status: DeclarationStatus;
  enabled?: boolean;
}

export const useGetDeclarationGroupsIds = ({ batchId, status, enabled = true }: HookProps) =>
  useQuery({
    queryKey: ['declarations-groups-ids', batchId, status],
    queryFn: async (): Promise<Record<string, string[]>> => {
      try {
        const result = await apiClient.declarations.groupedDeclarationsIds.query({ query: { batchId, status } });
        if (result.status !== 200) throw result.body;

        return result.body.data;
      } catch (error) {
        showErrorToast(error, 'Failed getting the declarations group ids');
        return {};
      }
    },
    enabled: !!batchId && enabled,
    placeholderData: {},
    staleTime: Infinity,
  });
